export default {
    api: process.env.API_BASE_URL,
}



// WEBPACK FOOTER //
// ./src/serve.js